import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/'
import {
	getToken
} from '@/libs/util'

Vue.use(Router)

const Index = (resolve) => {
	import( /* webpackChunkName: "login" */ '@/pages/Index').then((module) => {
		resolve(module)
	})
}
/* 首页 */
const Home = (resolve) => {
	import( /* webpackChunkName: "index" */ '@/pages/home/Home').then((module) => {
		resolve(module)
	})
}
/* 挂号科室列表 */
const RegWaySelect = (resolve) => {
	import( /* webpackChunkName: "register" */ '@/pages/register/RegWaySelect').then((module) => {
		resolve(module)
	})
}
/* 挂号科室列表 */
const DepartmentList = (resolve) => {
	import( /* webpackChunkName: "register" */ '@/pages/register/DepartmentList').then((module) => {
		resolve(module)
	})
}
/* 人体图 */
const RegisterSymptomBody = (resolve) => {
	import( /* webpackChunkName: "register" */ '@/pages/register/RegisterSymptomBody').then((module) => {
		resolve(module)
	})
}
/* 症状列表 */
const RegisterSymptom = (resolve) => {
	import( /* webpackChunkName: "register" */ '@/pages/register/RegisterSymptom').then((module) => {
		resolve(module)
	})
}
/* 推荐科室 */
const RecommendDepartment = (resolve) => {
	import( /* webpackChunkName: "register" */ '@/pages/register/RecommendDepartment').then((module) => {
		resolve(module)
	})
}
/* 科室介绍-科室列表 */
const DepartmentIntroduction = (resolve) => {
	import( /* webpackChunkName: "introduction" */ '@/pages/introduction/DepartmentList').then((module) => {
		resolve(module)
	})
}
/* 科室介绍-科室详情 */
const DepartmentDetail = (resolve) => {
	import( /* webpackChunkName: "introduction" */ '@/pages/introduction/DepartmentDetail').then((module) => {
		resolve(module)
	})
}
/* 医院介绍 */
const HospitalIntroduction = (resolve) => {
	import( /* webpackChunkName: "introduction" */ '@/pages/introduction/HospitalDetail').then((module) => {
		resolve(module)
	})
}
const UserCenterIndex = (resolve) => {
	import( /* webpackChunkName: "user" */ '@/pages/user/UserCenterIndex').then((module) => {
		resolve(module)
	})
}
const DoctorList = (resolve) => {
	import( /* webpackChunkName: "doctor" */ '@/pages/register/DoctorList').then((module) => {
		resolve(module)
	})
}
const DoctorIndex = (resolve) => {
	import( /* webpackChunkName: "doctor" */ '@/pages/register/DoctorIndex').then((module) => {
		resolve(module)
	})
}
/* 医生介绍 wxt.lxq 2019-5-9 */
const DoctorIntroduction = (resolve) => {
	import( /* webpackChunkName: "doctor" */ '@/pages/register/DoctorDetail').then((module) => {
		resolve(module)
	})
}
/* 医生介绍详情 wxt.lfy 2020-05-21 */
const DoctorIntroductionDetail = (resolve) => {
  import( /* webpackChunkName: "doctor" */ '@/pages/register/DoctorIntroductionDetail').then((module) => {
    resolve(module)
  })
}
const ConfirmRegister = (resolve) => {
	import( /* webpackChunkName: "register" */ '@/pages/register/ConfirmRegister').then((module) => {
		resolve(module)
	})
}
const RegisterOrderDetails = (resolve) => {
	import( /* webpackChunkName: "order" */ '@/pages/register/RegisterOrderDetails').then((module) => {
		resolve(module)
	})
}
const Pay = (resolve) => {
	import( /* webpackChunkName: "pay" */ '@/pages/order/Pay').then((module) => {
		resolve(module)
	})
}
const PayResult = (resolve) => {
	import( /* webpackChunkName: "pay" */ '@/pages/order/PayResult').then((module) => {
		resolve(module)
	})
}
const RecipeList = (resolve) => {
	import( /* webpackChunkName: "recipe" */ '@/pages/treat/RecipeList').then((module) => {
		resolve(module)
	})
}
const RecipeDetail = (resolve) => {
	import( /* webpackChunkName: "recipe" */ '@/pages/treat/RecipeDetail').then((module) => {
		resolve(module)
	})
}
const RecipeOrderDetail = (resolve) => {
	import( /* webpackChunkName: "recipe" */ '@/pages/treat/RecipeOrderDetail').then((module) => {
		resolve(module)
	})
}
const ReportList = (resolve) => {
	import( /* webpackChunkName: "report" */ '@/pages/report/ReportList').then((module) => {
		resolve(module)
	})
}
const ReportDetail = (resolve) => {
	import( /* webpackChunkName: "test" */ '@/pages/report/ReportDetail').then((module) => {
		resolve(module)
	})
}
const CardBind = (resolve) => {
	import( /* webpackChunkName: "card" */ '@/pages/card/CardBind').then((module) => {
		resolve(module)
	})
}
const CardApply = (resolve) => {
	import( /* webpackChunkName: "card" */ '@/pages/card/CardApply').then((module) => {
		resolve(module)
	})
}
const CardList = (resolve) => {
	import( /* webpackChunkName: "card" */ '@/pages/card/CardList').then((module) => {
		resolve(module)
	})
}
const CardDetail = (resolve) => {
	import( /* webpackChunkName: "card" */ '@/pages/card/CardDetail').then((module) => {
		resolve(module)
	})
}
const MyRegisterRecord = (resolve) => {
	import( /* webpackChunkName: "user" */ '@/pages/user/MyRegisterRecord').then((module) => {
		resolve(module)
	})
}
const MyNatRegisterRecord = (resolve) => {
	import( /* webpackChunkName: "user" */ '@/pages/user/MyNatRegisterRecord').then((module) => {
		resolve(module)
	})
}
const MyTreatRecord = (resolve) => {
	import( /* webpackChunkName: "user" */ '@/pages/user/MyTreatRecord').then((module) => {
		resolve(module)
	})
}
const MyPayRecord = (resolve) => {
	import( /* webpackChunkName: "user" */ '@/pages/user/MyPayRecord').then((module) => {
		resolve(module)
	})
}
/* 意见反馈 wxt.lxq 2019-5-10 */
const MyFeedback = (resolve) => {
	import( /* webpackChunkName: "user" */ '@/pages/user/MyFeedback').then((module) => {
		resolve(module)
	})
}
const MyCollection = (resolve) => {
	import( /* webpackChunkName: "user" */ '@/pages/user/MyCollection').then((module) => {
		resolve(module)
	})
}
/* 用户指南 wxt.lj 2019-5-9 */
const GuideQuestions = (resolve) => {
	import( /* webpackChunkName: "questions" */ '@/pages/faq/GuideQuestions').then((module) => {
		resolve(module)
	})
}
/* 常见问题 wxt.lj 2019-5-10 */
const GetQuestion = (resolve) => {
	import( /* webpackChunkName: "doctor" */ '@/pages/user/Questions').then((module) => {
		resolve(module)
	})
}
// 预缴住院板块
const InHosIndex = (resolve) => {
	import( /* webpackChunkName: "doctor" */ '@/pages/inhos/InHosIndex').then((module) => {
		resolve(module)
	})
}
const InHosDailyList = (resolve) => {
	import( /* webpackChunkName: "doctor" */ '@/pages/inhos/InHosDailyList').then((module) => {
		resolve(module)
	})
}
const InHosRecharge = (resolve) => {
	import( /* webpackChunkName: "doctor" */ '@/pages/inhos/InHosRecharge').then((module) => {
		resolve(module)
	})
}
const InHosOrderDetail = (resolve) => {
	import( /* webpackChunkName: "doctor" */ '@/pages/inhos/InHosOrderDetail').then((module) => {
		resolve(module)
	})
}
const SurveyList = (resolve) => {
	import( /* webpackChunkName: "doctor" */ '@/pages/survey/SurveyList').then((module) => {
		resolve(module)
	})
}
const SurveyContent = (resolve) => {
	import( /* webpackChunkName: "doctor" */ '@/pages/survey/SurveyContent').then((module) => {
		resolve(module)
	})
}
const NatRegister = (resolve) => {
	import( /* webpackChunkName: "doctor" */ '@/pages/nat/NatRegister').then((module) => {
		resolve(module)
	})
}


const router = new Router({
	routes: [{
			path: '/',
			name: 'Login',
			component: Index,
			meta: {
				title: "登录"
			}
		},
		{
			path: '/home',
			name: 'Home',
			component: Home,
			meta: {
				title: "攀煤总医院"
			}
		},
		{
			path: '/user',
			name: 'UserCenterIndex',
			component: UserCenterIndex,
			meta: {
				title: "个人中心"
			}
		},
		{
			path: '/user/register',
			name: 'MyRegisterRecord',
			component: MyRegisterRecord,
			meta: {
				title: "我的预约挂号"
			}
		},
    {
      path: '/user/natRegister',
      name: 'MyNatRegisterRecord',
      component: MyNatRegisterRecord,
      meta: {
        title: "核酸预约记录"
      }
    },
		{
			path: '/user/pay',
			name: 'MyPayRecord',
			component: MyPayRecord,
			meta: {
				title: "支付记录"
			}
		},
		{
			path: '/feedback',
			name: 'MyFeedback',
			component: MyFeedback,
			meta: {
				title: "意见反馈"
			}
		},
		{
			path: '/user/treat',
			name: 'MyTreatRecord',
			component: MyTreatRecord,
			meta: {
				title: "缴费记录"
			}
		},
		{
			path: '/user/collection',
			name: 'MyCollection',
			component: MyCollection,
			meta: {
				title: "我的收藏"
			}
		},
		{
			path: '/register',
			name: 'RegWaySelect',
			component: RegWaySelect,
			meta: {
				title: "挂号方式"
			}
		},
		{
			path: '/register/dept',
			name: 'DepartmentList',
			component: DepartmentList,
			meta: {
				title: "科室列表"
			}
		},
		{
			path: '/departindex',
			name: 'DepartmentIntroduction',
			component: DepartmentIntroduction,
			meta: {
				title: "科室介绍"
			}
		},
		{
			path: '/departdetail/:departId',
			name: 'DepartmentDetail',
			props: true,
			component: DepartmentDetail,
			meta: {
				title: "科室信息"
			}
		},
		{
			path: '/hospitalindex',
			name: 'HospitalIntroduction',
			component: HospitalIntroduction,
			meta: {
				title: "医院介绍"
			}
		},
		{
			path: '/register/doctor/list',
			name: 'DoctorList',
			props: true,
			component: DoctorList,
			meta: {
				title: "号源列表"
			}
		},
		{
			path: '/register/doctor/index/:doctorId',
			name: 'DoctorIndex',
			props: true,
			component: DoctorIndex,
			meta: {
				title: "科室首页"
			}
		},
		{
			path: '/doctor',
			name: 'DoctorIntroduction',
			props: true,
			component: DoctorIntroduction,
			meta: {
				title: "医生介绍"
			}
		},
    {
      path: '/register/doctor/Introduction/Detail/:doctorId',
      name: 'DoctorIntroductionDetail',
      props: true,
      component: DoctorIntroductionDetail,
      meta: {
        title: "医生介绍详情"
      }
    },
		{
			path: '/register/symptom/body',
			name: 'RegisterSymptomBody',
			props: true,
			component: RegisterSymptomBody,
			meta: {
				title: "人体图"
			}
		},
		{
			path: '/register/symptom',
			name: 'RegisterSymptom',
			props: true,
			component: RegisterSymptom,
			meta: {
				title: "症状列表"
			}
		},
		{
			path: '/register/recommendDepartment',
			name: 'RecommendDepartment',
			props: true,
			component: RecommendDepartment,
			meta: {
				title: "推荐科室"
			}
		},
		{
			path: '/register/confirm',
			name: 'ConfirmRegister',
			props: true,
			component: ConfirmRegister,
			meta: {
				title: "确认预约挂号信息"
			}
		},
		{
			path: '/register/order/:orderId',
			name: 'RegisterOrderDetails',
			props: true,
			component: RegisterOrderDetails,
			meta: {
				title: "预约挂号详情"
			}
		},
		{
			path: '/order/pay/:orderId',
			name: 'Pay',
			props: true,
			component: Pay,
			meta: {
				title: "支付"
			}
		},
		{
			path: '/order/pay/result/:orderId',
			name: 'PayResult',
			props: true,
			component: PayResult,
			meta: {
				title: "支付结果"
			}
		},
		{
			path: '/recipe',
			name: 'RecipeList',
			props: true,
			component: RecipeList,
			meta: {
				title: "处方列表"
			}
		},
		{
			path: '/recipe/detail/:recipeNo',
			name: 'RecipeDetail',
			props: true,
			component: RecipeDetail,
			meta: {
				title: "处方详情"
			}
		},
		{
			path: '/recipe/order/:orderId',
			name: 'RecipeOrderDetail',
			props: true,
			component: RecipeOrderDetail,
			meta: {
				title: "处方支付详情"
			}
		},
		{
			path: '/report',
			name: 'ReportList',
			props: true,
			component: ReportList,
			meta: {
				title: "报告列表"
			}
		},
		{
			path: '/report/detail/:reportNo',
			name: "ReportDetail",
			props: true,
			component: ReportDetail,
			meta: {
				title: "报告详情"
			}
		},
		{
			path: '/card/bind',
			name: "CardBind",
			props: true,
			component: CardBind,
			meta: {
				title: "绑定就诊卡"
			}
		},
		{
			path: '/card/apply',
			name: "CardApply",
			props: true,
			component: CardApply,
			meta: {
				title: "在线办卡"
			}
		},
		{
			path: '/card/list',
			name: "CardList",
			props: true,
			component: CardList,
			meta: {
				title: "我的就诊卡"
			}
		},
		{
			path: '/card/detail/:id',
			name: "CardDetail",
			props: true,
			component: CardDetail,
			meta: {
				title: "就诊卡详情"
			}
		},
		{
			path: '/guide',
			name: "GuideQuestions",
			props: true,
			component: GuideQuestions,
			meta: {
				title: "用户指南"
			}
		},
		{
			path: '/questions',
			name: "Questions",
			props: true,
			component: GetQuestion,
			meta: {
				title: "常见问题"
			}
		},
		{
			path: '/inhos',
			name: "InHosIndex",
			props: true,
			component: InHosIndex,
			meta: {
				title: "住院信息"
			}
		},
		{
			path: '/inhos/daily/:hosCardNo/:hosCardType/:inHosNo',
			name: "InHosDailyList",
			props: true,
			component: InHosDailyList,
			meta: {
				title: "住院一日清单"
			}
		},
		{
			path: '/inhos/recharge/:hosCardNo/:hosCardType',
			name: "InHosRecharge",
			props: true,
			component: InHosRecharge,
			meta: {
				title: "住院费预缴"
			}
		},
		{
			path: '/inhos/order/:orderId',
			name: "InHosOrderDetail",
			props: true,
			component: InHosOrderDetail,
			meta: {
				title: "住院预缴详情"
			}
		},
		{
			path: '/survey',
			name: "SurveyList",
			props: true,
			component: SurveyList,
			meta: {
				title: "调查问卷列表"
			}
		},
		{
			path: '/survey/surveyContent',
			name: "SurveyContent",
			props: true,
			component: SurveyContent,
			meta: {
				title: "问卷详情"
			}
		},
    {
      path: '/natRegister',
      name: 'NatRegister',
      props: true,
      component: NatRegister,
      meta: {
        title: "核酸检测预约"
      }
    },
	]
})



const LOGIN_PAGE = '/';
const HOME_PAGE = '/home';

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;
	}

	const token = getToken()

	if (!token && to.path !== LOGIN_PAGE) {
		// 未登录且要跳转的页面不是登录页
		var query = to.query || {};
		query.toPath = to.path;
		next({
			path: LOGIN_PAGE, // 跳转到登录页
			query: query
		})
	} else if (!token && to.path === LOGIN_PAGE) {
		// 未登陆且要跳转的页面是登录页
		next() // 跳转
	} else if (token && to.path === LOGIN_PAGE) {
		// 已经登录的且访问的是登录页
		next({
			path: HOME_PAGE, // 跳转到首页
			query: to.query
		})
	} else {
		// 已经登录的
		store.dispatch('loadUserInfo').then(user => {
			// 拉取用户信息
			var query = to.query || {};
			if (query.toPath && to.path != query.toPath) {
				next({
					path: query.toPath,
					query: to.query
				})
			} else {
				next()
			}
		});
	}
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js